export const movementStatus = {
  Pending: 0,
  Complete: 1,
  Undone: 2,
};
